import apiClient from "config/apiClient";
import Notify from "config/notify";
import handle_error from "../../../util/handle_error";

interface LoginResponse {
  access_token: string;
  refresh_token: string;
}

/**
 * @param email email
 */
export const forgotPasswordApi = async (email: string) => {
  const response = await apiClient.post("/mst/user/auth/password/reset/request", {
    email_address: email,
  });
  if (response.status === 200) {
    Notify.setNotification({
      show: true,
      title: "メールを送信しました。",
      confirmLabel: "OK",
      actionsPosition: "end"
    })
  }
};

/**
 * @param passwordResetToken passwordResetToken
 * @param newPassword password
 */
export const resetPasswordApi = async (passwordResetToken: string, newPassword: string) => {
  const response = await apiClient.post<LoginResponse>("/mst/user/auth/password/reset", {
    password_reset_token: passwordResetToken,
    new_password: newPassword,
  });
  if (response.status === 200) {
    Notify.setNotification({
      show: true,
      title: "パスワードの変更が完了しました。",
      confirmLabel: "OK",
      actionsPosition: "end"
    })
  }
  return response;
};
